<template>
  <div class="text-center" v-if="$apollo.queries.getSiteById.loading">
    <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_SITE_BY_ID = gql`
query getSiteById($siteId: Int) {
  getSiteById(siteId: $siteId) {
    id
    name
    sitePoint{
      lat
      lng
    }
  }
}
`
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
  methods: {
    drawSite(sitePoints) {
      const { Polygon } = this.google.maps
      const site = new Polygon({
        path: sitePoints,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
      })
      site.setMap(this.map)
    },
  },
  apollo: {
    getSiteById: {
      query: GET_SITE_BY_ID,
      variables() {
        return {
          siteId: this.$route.params.id,
        }
      },
      result({ data }) {
        this.map.setCenter(data.getSiteById.sitePoint[0])
        this.map.setZoom(11)
        this.drawSite(data.getSiteById.sitePoint)
      },
      error(err) {
        console.log(err)
      },
      context: headers(),
    },
  },
  created() {
    console.log(this.$route.params.id, 'sitio')
  },
  // eslint-disable-next-line vue/require-render-return
  render() {},
}
</script>
